import { useNavigate } from "react-router-dom";
import { useEffect, useState, useCallback } from "react";
import { deleteDiary, getDiaries } from "./.request";
import { useAuth } from "../context/AuthContext";
import { IMAGE_URL } from "../constants/Consts";
import CircularProgress from '@mui/material/CircularProgress';

const NoorDiary = () => {
    const navigate = useNavigate();
    const [dires, setDires] = useState([]);
    const { authToken, themeMode } = useAuth();
    const isDark = themeMode === 'dark';
    const IMAGE_SHOW = `${IMAGE_URL}diaryImages`;
    const [loading, setLoading] = useState(false);

    const getDiariesList = useCallback(async () => {
        try {
            const response = await getDiaries(authToken);
            if (response.Result) {
                setDires(response.Diaries || []);
            } else {
                console.error("Failed to fetch diaries:", response.Msg);
            }
        } catch (error) {
            console.error("Error fetching diaries:", error);
        }
    }, [authToken]);

    useEffect(() => {
        getDiariesList();
    }, [authToken, getDiariesList]);

    const handleEditDiary = (diaryId)=>{
        navigate('/noor-diary/editNoorDiary', { state: { diaryId } });
    };

    const handleDelete = async(id)=>{
        if (!window.confirm("Are you sure you want to delete this diary?")) return;
        setLoading(true);
        try {
            const response = await deleteDiary(authToken, id);
            if(response.Result){
                alert('Diary Deleted Successfully');
                getDiariesList();
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-6 pb-8">
            {/* Header */}
            <div className="glass-panel p-6 flex justify-between items-center">
                <div>
                    <h1 className={`font-extrabold text-2xl sm:text-3xl ${isDark ? 'text-white' : 'text-slate-900'}`}>Noor Diary</h1>
                    <p className={`text-xs mt-1 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>Manage Noor Diary covers, editions, and annual archives</p>
                </div>
                <button
                    onClick={() => navigate('/noor-diary/createNoorDiary')}
                    className="glass-btn-primary px-5 py-2.5 text-xs font-semibold flex items-center gap-2"
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={16} color="inherit" /> : '+ Add Diary'}
                </button>
            </div>

            {/* Diary Table */}
            <div className="glass-panel overflow-hidden">
                <div className="overflow-x-auto">
                    <table className="w-full min-w-full glass-table">
                        <thead>
                            <tr>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Cover</th>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Year</th>
                                <th className="py-3.5 px-4 text-center font-semibold text-xs uppercase tracking-wider">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {dires.length > 0 ? (
                                dires.map((diary) => (
                                    <tr key={diary.id || diary._id} className="transition-colors hover:bg-white/5">
                                        <td className="py-3.5 px-4 text-center">
                                            <div className="flex justify-center items-center">
                                                {diary.image ? (
                                                    <img 
                                                        src={`${IMAGE_SHOW}/${diary.image}`} 
                                                        alt="Cover" 
                                                        className="w-24 h-16 object-cover rounded-lg border border-white/10 shadow-sm" 
                                                    />
                                                ) : (
                                                    <div className="w-24 h-16 rounded-lg bg-slate-800/60 border border-white/10 flex items-center justify-center text-xs text-slate-500">No Image</div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="py-3.5 px-4 text-center text-xs font-mono font-bold text-cyan-400">{diary.year}</td>
                                        <td className="py-3.5 px-4 text-center">
                                            <div className="flex items-center justify-center space-x-2">
                                                <button 
                                                    className="glass-btn-secondary px-4 py-1.5 text-xs font-medium"
                                                    onClick={()=>handleEditDiary(diary.id)} 
                                                    disabled={loading}
                                                >
                                                    View / Edit
                                                </button>
                                                <button 
                                                    className="glass-btn-danger px-4 py-1.5 text-xs font-medium"
                                                    onClick={()=>handleDelete(diary.id)} 
                                                    disabled={loading}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="py-8 text-center text-sm text-slate-400">No diaries found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default NoorDiary;
